import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../utils/api';
import { Spinner } from '../../components/UI';
import NuevoClienteForm from '../../components/NuevoClienteForm';

export default function Paso1Cliente({ datos, onChange, onSiguiente, requiereKm = true }) {
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(datos.cliente || null);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(datos.vehiculo || null);
  const [vehiculos, setVehiculos] = useState([]);
  const [km, setKm] = useState(datos.kilometraje || '');
  const [modoNuevo, setModoNuevo] = useState(false);

  // Búsqueda con debounce
  useEffect(() => {
    if (busqueda.length < 2) { setResultados([]); return; }
    const t = setTimeout(async () => {
      setBuscando(true);
      try {
        const res = await api(`/clientes?q=${encodeURIComponent(busqueda)}`);
        const vistos = new Set();
        const dedup = res.filter(r => { if (vistos.has(r.id)) return false; vistos.add(r.id); return true; });
        setResultados(dedup);
      } catch { setResultados([]); }
      setBuscando(false);
    }, 300);
    return () => clearTimeout(t);
  }, [busqueda]);

  const seleccionarCliente = useCallback(async (c) => {
    setClienteSeleccionado(c);
    setResultados([]);
    setBusqueda('');
    const veh = await api(`/vehiculos/cliente/${c.id}`);
    setVehiculos(veh);
    if (veh.length === 1) setVehiculoSeleccionado(veh[0]);
    else setVehiculoSeleccionado(null);
  }, []);

  const handleClienteCreado = (clienteCreado, vehiculoCreado) => {
    setClienteSeleccionado(clienteCreado);
    setVehiculoSeleccionado(vehiculoCreado);
    setModoNuevo(false);
  };

  const puedeAvanzar = clienteSeleccionado && vehiculoSeleccionado && (!requiereKm || (km && parseInt(km) > 0));

  const handleSiguiente = () => {
    onChange({
      cliente: clienteSeleccionado,
      vehiculo: vehiculoSeleccionado,
      kilometraje: km,
    });
    onSiguiente();
  };

  if (modoNuevo) return (
    <div>
      <div className="sec-header">
        <h2 className="sec-title">Nuevo cliente</h2>
      </div>
      <NuevoClienteForm onCreado={handleClienteCreado} onCancelar={() => setModoNuevo(false)} />
    </div>
  );

  return (
    <div>
      <div className="sec-header">
        <h2 className="sec-title">Cliente y vehículo</h2>
        <button className="btn btn-outline btn-sm" onClick={() => setModoNuevo(true)}>
          + Nuevo cliente
        </button>
      </div>

      {!clienteSeleccionado && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <div className="form-group">
            <label className="form-label">Buscar cliente por nombre o matrícula</label>
            <div className="search-wrap">
              <span className="search-icon">🔍</span>
              <input className="form-input" placeholder="Ej: Torres, SCY8805..."
                value={busqueda} onChange={e => setBusqueda(e.target.value)} />
            </div>
          </div>

          {buscando && <Spinner texto="Buscando..." />}

          {resultados.length > 0 && (
            <div style={{ marginTop: '.5rem', border: '1px solid var(--gris-2)', borderRadius: 'var(--radio)', overflow: 'hidden' }}>
              {resultados.map(c => (
                <button key={c.id} onClick={() => seleccionarCliente(c)}
                  style={{
                    display: 'block', width: '100%', textAlign: 'left',
                    padding: '.6rem .9rem', background: 'white', border: 'none',
                    borderBottom: '1px solid var(--gris-2)', cursor: 'pointer',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--gris-1)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}
                >
                  <span style={{ fontWeight: 500 }}>{c.nombre}</span>
                  {c.matricula && <span style={{ color: 'var(--gris-4)', marginLeft: '.5rem', fontSize: '.8125rem' }}>{c.matricula}</span>}
                  {c.marca && <span style={{ color: 'var(--gris-4)', marginLeft: '.5rem', fontSize: '.8125rem' }}>{c.marca} {c.modelo}</span>}
                </button>
              ))}
            </div>
          )}

          {busqueda.length >= 2 && !buscando && resultados.length === 0 && (
            <p style={{ color: 'var(--gris-4)', marginTop: '.5rem', fontSize: '.875rem' }}>
              Sin resultados. <button className="btn btn-outline btn-sm" style={{ marginLeft: '.5rem' }} onClick={() => setModoNuevo(true)}>Crear nuevo cliente</button>
            </p>
          )}
        </div>
      )}

      {clienteSeleccionado && (
        <div className="card" style={{ marginBottom: '1rem', borderLeft: '3px solid var(--azul-medio)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <p style={{ fontWeight: 600, fontSize: '1rem' }}>{clienteSeleccionado.nombre}</p>
              {clienteSeleccionado.celular && <p style={{ color: 'var(--gris-4)', fontSize: '.875rem' }}>📱 {clienteSeleccionado.celular}</p>}
              {clienteSeleccionado.rut && <p style={{ color: 'var(--gris-4)', fontSize: '.875rem' }}>RUT: {clienteSeleccionado.rut}</p>}
              <span className="badge badge-gris" style={{ marginTop: '.25rem' }}>{clienteSeleccionado.id}</span>
            </div>
            <button className="btn btn-secondary btn-sm" onClick={() => { setClienteSeleccionado(null); setVehiculoSeleccionado(null); setVehiculos([]); }}>
              Cambiar
            </button>
          </div>
        </div>
      )}

      {vehiculos.length > 1 && !vehiculoSeleccionado && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <p style={{ fontWeight: 500, marginBottom: '.5rem' }}>Seleccioná el vehículo:</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.4rem' }}>
            {vehiculos.map(v => (
              <button key={v.id} className="btn btn-outline" style={{ justifyContent: 'flex-start' }}
                onClick={() => setVehiculoSeleccionado(v)}>
                🚗 {v.marca} {v.modelo} {v.matricula ? `| ${v.matricula}` : ''}
              </button>
            ))}
          </div>
        </div>
      )}

      {vehiculoSeleccionado && (
        <div className="card" style={{ marginBottom: '1rem', borderLeft: '3px solid var(--verde)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.6rem' }}>
            <p style={{ fontWeight: 600, fontSize: '1rem' }}>🚗 {vehiculoSeleccionado.marca} {vehiculoSeleccionado.modelo}</p>
            {vehiculos.length > 1 && (
              <button className="btn btn-secondary btn-sm" onClick={() => setVehiculoSeleccionado(null)}>Cambiar</button>
            )}
          </div>

          <div className="resumen-grid">
            {vehiculoSeleccionado.matricula && <div className="resumen-card"><div className="label">Matrícula</div><div className="valor">{vehiculoSeleccionado.matricula}</div></div>}
            {vehiculoSeleccionado.anio && <div className="resumen-card"><div className="label">Año</div><div className="valor">{vehiculoSeleccionado.anio}</div></div>}
            {vehiculoSeleccionado.motor && <div className="resumen-card"><div className="label">Motor</div><div className="valor">{vehiculoSeleccionado.motor}</div></div>}
            {vehiculoSeleccionado.combustible && <div className="resumen-card"><div className="label">Combustible</div><div className="valor">{vehiculoSeleccionado.combustible}</div></div>}
            {vehiculoSeleccionado.transmision && <div className="resumen-card"><div className="label">Transmisión</div><div className="valor">{vehiculoSeleccionado.transmision}</div></div>}
            {vehiculoSeleccionado.admision && <div className="resumen-card"><div className="label">Admisión</div><div className="valor">{vehiculoSeleccionado.admision}</div></div>}
          </div>

          <div className="form-group" style={{ marginTop: '1rem', maxWidth: 200 }}>
            <label className="form-label">
              Kilometraje {requiereKm ? <span className="req">*</span> : <span style={{ color: 'var(--gris-4)', fontWeight: 400 }}>(opcional)</span>}
            </label>
            <input className="form-input" type="number" placeholder="Ej: 75000"
              value={km} onChange={e => setKm(e.target.value)} />
            {requiereKm && !km && <span style={{ fontSize: '.75rem', color: 'var(--rojo)' }}>El kilometraje es obligatorio</span>}
          </div>
        </div>
      )}

      <button className="btn btn-primary btn-full" disabled={!puedeAvanzar}
        onClick={handleSiguiente}>
        Continuar → Servicios
      </button>
    </div>
  );
}
